import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 cursor-pointer mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-circle-fill text-foreground-50 text-xl"></i>
                </div>
                <span className="text-lg font-bold text-foreground-50 font-heading">樱桃视频</span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {siteInfo.description.slice(0, 80)}...
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
                <Link to="/category/dianying" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">电影</Link>
                <Link to="/category/dianshiju" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">电视剧</Link>
                <Link to="/category/zongyi" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">综艺</Link>
                <Link to="/category/dongman" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">动漫</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">热门分类</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/jilupian" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">纪录片</Link>
                <Link to="/category/tiyu" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">体育</Link>
                <Link to="/category/yinyue" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">音乐</Link>
                <Link to="/category/youxi" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">游戏</Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">联系我们</h4>
              <div className="flex flex-col gap-2 text-sm text-foreground-400">
                <span>邮箱：contact@yingtaovideo.com</span>
                <span>微信：yingtaovideo_official</span>
                <span>微博：@樱桃视频官方</span>
              </div>
            </div>
          </div>

          <div className="border-t border-background-200/60 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600">
              &copy; {new Date().getFullYear()} 樱桃视频 YingTaoVideo.com 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}